import { useContext } from "react"
import { ItemContext } from "./ItemContext"
import type { ItemContextValue } from "./ItemContextValue"

export function useItemContext(): ItemContextValue {
  return useContext(ItemContext)
}
